

export default class CustomFormExtendable {

    static getInputComponent(type, props) {
        return null;
    }

    static normalizeValue(value, type) {
        return value;
    }

    static checkError(type, value, rules, options, allValues) {
        return null;
    }

    static parseRequiredRuleValue(ruleValue) {
        return ruleValue === true;
    }
}
